module.exports = __webpack_public_path__ + "img/btn.17f8f94c.png";